// Common
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule }   from '@angular/forms';
import { ChartsModule } from 'ng2-charts/ng2-charts';
import { DropdownModule } from 'ng2-bootstrap/dropdown'; 
import { DebtsRoutingModule } from './debts-routing.module';


import { TabsModule } from 'ng2-bootstrap/tabs'; 
// End Common

// Component
import { DebtsComponent } from './debts.component';
import { ImportComponent } from './import.component';
import { ReceivableComponent } from './receivable.component';
import { VehicleComponent } from './vehicle.component';
import { VehiclesComponent } from './vehicles.component';
import { ViewdebtComponent } from './viewdebt.component';

import { ViewvehicleComponent } from './viewvehicle.component';

import { UploadcollectionComponent } from './uploadcollection.component';

import { CollectionComponent } from './collection.component';

import { CollectedComponent } from './collected.component';

import { EditComponent } from './edit.component';
import { EditblondalComponent } from './editblondal.component';
// End Component

// Services
import { VehicleService } from '../_Services/vehicle.service';
import { DebtService } from '../_Services/debt.service'; 
import { CommonService } from '../_Services/common.service'; 
// Services
import { FileUploadModule } from 'ng2-file-upload';

// Pagination
import { NgxPaginationModule } from 'ngx-pagination';
 

@NgModule({
  imports: [
    DebtsRoutingModule, 
    ChartsModule,
    DropdownModule ,
    CommonModule,
    FormsModule,
    TabsModule, 
    NgxPaginationModule,
    FileUploadModule
  ],
  declarations: [ 
  	DebtsComponent,
  	ImportComponent,
  	ReceivableComponent,
  	VehicleComponent,
  	VehiclesComponent,
  	ViewdebtComponent,  
    ViewvehicleComponent,
    UploadcollectionComponent,
    CollectionComponent,
    CollectedComponent,
    EditComponent,
    EditblondalComponent
  ],
  providers: [
    VehicleService,
    DebtService,
    CommonService
  ]
})
export class DebtsModule { }
 


// WEBPACK FOOTER //
// ./src/app/debts/debts.module.ts